/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { ModalGeneric, Loader } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import { getTotalOfLine } from '../../../services/workReport';
import useToast from '../../../hooks/useToast';
import { getMonthlyTotalOfLine } from '../../../services/monthlyServiceRequest';
import './TotalLineModal.scss';

import TotalLineSummary from './TotalLineSummary/TotalLineSummary';
import TotalLineTable from './TotalLineTable/TotalLineTable';

import '../WorkReportModals.scss';

const TotalLineModal = ({ idLine, monthly, show, onHide }) => {
  const [lineInfo, setLineInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const { setNewToast } = useToast();

  const fetchData = async () => {
    setLoading(true);
    try {
      let response;

      if (monthly) {
        response = await getMonthlyTotalOfLine(idLine);
      } else {
        response = await getTotalOfLine(idLine);
      }
      setLineInfo(response);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (show) {
      fetchData();
    }
    if (!show) {
      setLineInfo(null);
    }
  }, [idLine, show]);

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onHide}
      primaryAction={onHide}
      primaryActionLabel="Salir"
      show={show}
      size="lg"
      title="Ver total de la línea"
    >
      <>
        <p className="text-center modal-info">
          {lineInfo && (
            <>
              &quot;{lineInfo?.detalle} ({lineInfo?.unidadMedida})&quot;
              <br />
            </>
          )}
          Total de la línea para todo el parte de trabajo cargado hasta el momento
        </p>
        <hr className="divide-line mt-4 mb-5" />
        <div className="summary-tab-table">
          <TotalLineSummary className="summary-table-cards" lineInfo={lineInfo} />
          <TotalLineTable dailyWorkReports={lineInfo?.parteTrabajoDiarios} />
        </div>
        <hr className="divide-line mt-4" />
        <Loader show={loading} text="CARGANDO" />
      </>
    </ModalGeneric>
  );
};

export default TotalLineModal;

TotalLineModal.propTypes = {
  idLine: PropTypes.number,
  monthly: PropTypes.bool,
  show: PropTypes.bool,
  onHide: PropTypes.func
};

TotalLineModal.defaultProps = {
  idLine: null,
  monthly: false,
  show: false,
  onHide: () => {
    /* Empty */
  }
};
